import { useMutation, useQueryClient } from '@tanstack/react-query';
import { nationalityApi } from '../api/nationality.api';
import { nationalityKeys } from '../api/nationality.keys';
import toast from 'react-hot-toast';

export function useCreateNationality() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => nationalityApi.create(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: nationalityKeys.all });
      toast.success('Nationality created');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'Failed to create');
    },
  });
}

export function useUpdateNationality() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: any) => nationalityApi.update(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: nationalityKeys.all });
      toast.success('Nationality updated');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'Failed to update');
    },
  });
}

export function useDeleteNationality() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => nationalityApi.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: nationalityKeys.all });
      toast.success('Nationality deleted');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'Failed to delete');
    },
  });
}
